// The Skills/Behaviors present here should be kept in sync with the
// backend CURRENT_SKILL_CHOICES and CURRENT_BEHAVIOR_CHOICES
// Please do not change one without the other.

export const ORDERED_TRAINING_SKILL_LABELS_TO_SLUGS_MAP = new Map([
  ['Adult dog training', 'adult-dog-training'],
  ['Puppy training', 'puppy-training'],
  ['Advanced training', 'advanced-training'],
  ['Clicker training', 'clicker-training'],
]);

export const ORDERED_TRAINING_BEHAVIOR_LABELS_TO_SLUGS_MAP = new Map([
  ['Barking', 'barking'],
  ['Leash manners', 'leash-manners'],
  ['Leash reactivity', 'leash-reactivity'],
  ['House manners', 'house-manners'],
  ['Jumping', 'jumping'],
  ['Fearful behavior', 'fearful-behavior'],
  ['Anxious behavior', 'anxious-behavior'],
  ['Separation distress', 'separation-distress'],
  ['Recall', 'recall'],
  ['Biting', 'biting'],
  ['Chewing', 'chewing'],
  ['Mouthiness', 'mouthiness'],
  ['Potty training', 'potty-training'],
  ['Resource guarding', 'guarding-resources'],
]);

export const CURRENT_SKILL_SLUGS_TO_LABELS = {
  'adult-dog-training': 'Adult dog training',
  'puppy-training': 'Puppy training',
  'advanced-training': 'Advanced training',
  'clicker-training': 'Clicker training',
};

export const CURRENT_BEHAVIOR_SLUGS_TO_LABELS = {
  barking: 'Barking',
  'leash-manners': 'Leash manners',
  'leash-reactivity': 'Leash reactivity',
  'house-manners': 'House manners',
  jumping: 'Jumping',
  'fearful-behavior': 'Fearful behavior',
  'anxious-behavior': 'Anxious behavior',
  'separation-distress': 'Separation distress',
  recall: 'Recall',
  biting: 'Biting',
  chewing: 'Chewing',
  mouthiness: 'Mouthiness',
  'potty-training': 'Potty training',
  'guarding-resources': 'Resource guarding',
};
